import { transactionStatus } from "pages/transactions/constants";
import * as i18n from "util/i18n";
import Action from "pages/_components/Action";
import Button from "pages/_components/Button";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { bool } from "prop-types";
import { useLocation } from "react-router-dom";
import { actions as contactActions } from "reducers/contactDestination";
import { isIOS } from "react-device-detect";
import { useTransaction } from "./hooks/useTransactions";
import ContactSummaryBody from "./_components/ContactSummary";

const ContactTransactionPage = ({ isDesktop }) => {
    const { state = {}, pathname } = useLocation();
    const { isFlowComplete = false } = state;
    const middlePath = pathname.split("/")[2];
    const formatTransaction = (data, idTransaction) => {
        if (middlePath === "delete") {
            const { idFrequentDestination } = data;
            return {
                idFrequentDestination,
                idTransaction,
            };
        }
        const formData = {
            ...data,
            idTransaction,
        };
        return { ...formData, idTransaction };
    };

    const getTransactionSignAction = () => {
        switch (pathname.split("/")[2]) {
            case "modify":
                return contactActions.modifyFrequentDestinationPreviewRequest;
            case "delete":
                return contactActions.deleteFrequentDestinationPreviewRequest;
            default:
                return contactActions.frequentDestinationCreatePreview;
        }
    };

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        isBackoffice,
    } = useTransaction(getTransactionSignAction(), contactActions.cleanContactTicket, formatTransaction);

    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "transfer.contactDestination.title",
        id,
        "FrequentDestinations",
    );
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;
    const backLinkTo = isFlowComplete ? "/contactDestination" : "";

    useEffect(() => {
        if (isFlowComplete) {
            dispatch(contactActions.cleanFrecuentDestination());
            dispatch(contactActions.cleanFrecuentDestinationList());
        }
    }, [isFlowComplete]);

    return (
        <>
            {isFinished && <Notification scopeToShow="FrequentDestinations" />}
            <Notification scopeToShow="FrequentDestinationsTicket" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    metaTitle={`activities.${transaction.idActivity}`}
                    backLinkTo={isDesktop ? backLinkTo : "/contactDestination"}>
                    {isFinished && (
                        <>
                            <DesktopButtons>
                                <Button
                                    className="btn btn-outline"
                                    image="images/download.svg"
                                    label="global.download"
                                    onClick={handlePrint}
                                    block={false}
                                />
                            </DesktopButtons>
                            <MobileButtons
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }>
                                <Action labelKey="global.download" handleClick={handlePrintMobile} />
                                <Action labelKey="global.share" handleClick={handleShareMobile} />
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title={`activities.${transaction.idActivity}`} />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <ContactSummaryBody isTicket />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                />
                            </Col>
                            {showSignButton && (
                                <Col xs={12} md={4}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

ContactTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ContactTransactionPage;
